import { readonly, ref } from 'vue';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

const visible = ref<boolean>(document.visibilityState !== 'hidden');

/** Whether a passenger can see the app: the pollers pause while it is false. */
export const isAppVisible = readonly(visible);

export function setAppVisible(value: boolean) {
  visible.value = value;
}

export function initAppVisibility() {
  if (Capacitor.isNativePlatform()) {
    App.addListener('appStateChange', ({ isActive }) => setAppVisible(isActive));
    return;
  }
  document.addEventListener('visibilitychange', () => setAppVisible(document.visibilityState !== 'hidden'));
}
